var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc-container"},[_c('div',{staticClass:"tc-chart"},[_vm._m(0),_c('div',{ref:"myChart",staticClass:"myChart"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartTitle"},[_c('p',[_vm._v(" 客流饱和密度 "),_c('span',{staticStyle:{"color":"#59b0f9"}},[_vm._v("67%")])]),_c('p',[_vm._v(" 近一小时流量 "),_c('span',{staticStyle:{"color":"#feb72d"}},[_vm._v("643")]),_vm._v(" 人 ")])])
}]

export { render, staticRenderFns }